<template>
    <div class="relative w-full overflow-hidden">
        <div class="left-0 z-10 hidden h-[800px] w-1/2 bg-white lg:absolute lg:block"></div>
        <div
            class="normal-container relative flex flex-col-reverse gap-6 pt-11 pb-6 lg:grid lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-6 lg:py-20 lg:pt-12 xl:grid-cols-2">
            <div class="w-full">
                <div class="relative z-20 text-center xl:max-w-[550px] 2xl:max-w-[704px]">
                    <div
                        class="box-shadow-size absolute top-12 right-0 bottom-0 left-12 z-20 rounded-br-[24px] border-[3px] border-green-400 lg:rounded-br-3xl"></div>
                    <div
                        class="box-shadow-size absolute top-0 right-12 bottom-12 left-0 z-20 rounded-tl-[24px] border-[3px] border-green-400 lg:rounded-tl-3xl"></div>
                    <NuxtLink :to="brandUrl">
                        <ShopwareImg
                            v-if="product.manufacturer.media?.url"
                            class="relative z-30 aspect-square w-full object-cover px-5 py-5 lg:px-6 lg:py-6 xl:max-h-[600px] 2xl:max-h-[794px] 2xl:max-w-[704px]"
                            :alt="product.manufacturer.translated.name"
                            :src="product.manufacturer.media.url"
                            :width="704" />
                        <NuxtImg
                            v-else
                            class="relative z-30 aspect-square w-full object-cover px-6 py-6 xl:max-h-[600px] 2xl:max-h-[794px] 2xl:max-w-[704px]"
                            :alt="product.manufacturer.translated.name"
                            src="/brand-fallback.jpg" />
                    </NuxtLink>
                </div>
            </div>
            <!-- z-20: the absolute white half-panel (z-10) otherwise paints over the title/button
                 on viewports between lg and xl, where the container is narrower than the viewport -->
            <div class="relative z-20 flex min-w-0 flex-col lg:justify-center">
                <div class="lg:pt-6">
                    <h2 class="mb-4 text-xl lg:mb-10 lg:text-3xl">
                        {{ product.manufacturer.translated.name }}
                    </h2>
                    <p class="mb-4 lg:w-8/12" v-if="product.manufacturer.translated.description">
                        {{ product.manufacturer.translated.description }}
                    </p>
                    <NuxtLink class="btn btn-primary mb-[18px] hidden w-max lg:block" :to="brandUrl">
                        Ontdek alles van {{ product.manufacturer.translated.name }}
                    </NuxtLink>
                </div>
                <LazyUiSlider ref="slider" v-if="products.length > 0">
                    <div
                        v-for="(productItem, index) in products"
                        :class="[
                            'keen-slider__slide',
                            'number-slide' + index,
                            'max-w-[181px] min-w-[181px] lg:max-w-[281px] lg:min-w-[281px]',
                        ]">
                        <ShopwareProduct showLabels size="big" :product="productItem" />
                    </div>
                </LazyUiSlider>

                <div class="mt-6 lg:hidden">
                    <NuxtLink class="btn btn-primary mb-[18px] w-max lg:hidden" :to="brandUrl">
                        Ontdek alles van {{ product.manufacturer.translated.name }}
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    const brandUrl = ref('');
    const slider = useTemplateRef('slider');
    const props = defineProps<{ product: any; brandRecommendations?: any[] }>();

    const products = computed(() => props.brandRecommendations ?? []);

    const fetchBrandUrls = async () => {
        const manufacturerId = props.product.manufacturer.id;
        const urls = await useBrandUrls([manufacturerId]);
        if (urls.length === 0) {
            brandUrl.value = '/';
            return;
        }
        brandUrl.value = urls[manufacturerId]?.url || '/';
    };

    onMounted(() => {
        fetchBrandUrls();
    });

    onUpdated(() => {
        slider?.value?.update();
    });
</script>
